import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormRhombus"><Path d="M10.7196 1.64316C11.3041 0.683414 12.6977 0.683384 13.2821 1.64316L19.1112 11.2193C19.4028 11.6983 19.4026 12.3009 19.1112 12.7799L13.2821 22.3561C12.6977 23.3162 11.304 23.3162 10.7196 22.3561L4.89051 12.7799C4.59905 12.3009 4.59895 11.6983 4.89051 11.2193L10.7196 1.64316Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormRhombus;
